export default __webpack_public_path__ + "static/media/main-profile.d82c8d0e.jpg";